import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import type { ProjectDetail } from '../services/projectService';
import BacklogView from '../components/sprint/BacklogView';
import ActiveSprintView from '../components/sprint/ActiveSprintView';
import DailyScrumView from '../components/sprint/DailyScrumView';

export default function SprintPage() {
  const { project } = useOutletContext<{ project: ProjectDetail }>();
  const [activeSubTab, setActiveSubTab] = useState<'backlog' | 'active' | 'scrum'>('backlog');

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center gap-3 px-4 py-2 border-b border-gray-200">
        <h1 className="text-xl font-bold text-gray-900">스프린트</h1>
        <div className="flex bg-gray-100 rounded-lg p-0.5">
          <button
            onClick={() => setActiveSubTab('backlog')}
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
              activeSubTab === 'backlog'
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            백로그
          </button>
          <button
            onClick={() => setActiveSubTab('active')}
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
              activeSubTab === 'active'
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            활성 스프린트
          </button>
          <button
            onClick={() => setActiveSubTab('scrum')}
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
              activeSubTab === 'scrum'
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            스크럼
          </button>
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden p-4">
        {activeSubTab === 'backlog' ? (
          <BacklogView project={project} />
        ) : activeSubTab === 'active' ? (
          <ActiveSprintView project={project} />
        ) : (
          <DailyScrumView project={project} />
        )}
      </div>
    </div>
  );
}
